export default __webpack_public_path__ + "static/media/IPFS_logo.648ab605.png";